import { readState } from "@/__main__/app-state.mjs";

export function trimPatchForDisplay(patch = "") {
  const match = patch?.match(/(.*?\..*?)\./);
  return match ? match[1] : patch;
}

/**
 * getStaticPatchOf
 * which is used in getting static patch data from champion patch
 * @param patch : champion patch. ex:) 11.17
 * @returns : static patch. ex:) 11.17.1
 */
export function getStaticPatchOf(patch) {
  const patches = getAllValidPatches();
  const trimmedPatch = trimPatchForDisplay(patch);
  if (patches instanceof Error)
    throw new Error("Failed to load LoL patch info!");
  const p = patches.find((p) => p.versionString === trimmedPatch);
  return p ? `${p.versionString}.1` : null;
}

export function getAllValidPatches() {
  const { patchesFromStatic = [] } = readState.lol;
  const MAX_PATCHES = 5;

  if (!patchesFromStatic.length) return [];

  // Only return recent patches from API where static data exists.
  const result = patchesFromStatic
    .slice(0, MAX_PATCHES)
    .filter((p) => p.versionString.includes("."));

  // If no patches were found, fallback to HARD CODED PATCHES)
  // 🚨 THIS SHOULD NEVER HAPPEN 🚨
  if (!result.length) {
    return [
      {
        majorVersion: 15,
        minorVersion: 4,
        versionString: "15.4",
      },
      {
        majorVersion: 15,
        minorVersion: 3,
        versionString: "15.3",
      },
      {
        majorVersion: 15,
        minorVersion: 2,
        versionString: "15.2",
      },
      {
        majorVersion: 15,
        minorVersion: 1,
        versionString: "15.1",
      },
    ];
  }

  return result;
}

/**
 * getLatestPatchForStaticData
 * which is used in fetching static data
 * @returns full patch version. ex:) 11.17.1
 */
export function getLatestPatchForStaticData() {
  const patches = getAllValidPatches();
  return `${patches[0]?.versionString}.1`;
}

/**
 * getCurrentPatchForStaticData
 * which is used in fetching static data
 * @returns full patch version. ex:) 11.17.1
 */
export function getCurrentPatchForStaticData() {
  const patch = getStaticPatchOf(getCurrentPatchForChampions());
  return patch;
}

/**
 * getCurrentPatchForChampions
 * which is used in fetching champion aggregating data
 * @returns shorted patch version. ex:) 11.17
 */
export function getCurrentPatchForChampions() {
  const patches = getAllValidPatches();
  return patches[0]?.versionString || patches[1]?.versionString;
}

export function getAllPatchesForChampions() {
  const patches = getAllValidPatches();
  return patches.map((p) => p.versionString);
}
